import styled from 'styled-components';

const Wrapper = styled.aside`
  grid-area: aside;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  position: fixed;
  height: 100%;
  gap: 10px;
  z-index: 1;

  background-color: ${(props) => props.theme.colors.widget_background};

  font-size: 0;
  color: ${(p) => p.theme.colors.text};

  &.open {
    font-weight: 400;
    font-size: 12px;
    width: 145px;

    .nav-container {
      align-items: flex-start;
      overflow: auto;

      &::-webkit-scrollbar {
        width: 0;
      }
    }

    .sub-nav, .nav-list{
      width: 100%;
    }

    .menu-link {
      gap: 10px;
      justify-content: flex-start;
    }
  }

  .logo {
    width: 32px;
    margin-top: 16px;
    margin-bottom: 20px;
  }

  .nav-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 0;
    }
  }

  .menu-link {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 44px;
    padding: 12px 8px;
    text-align: center;
    margin-bottom: 5px;

    :hover {
      background-color: ${(props) => props.theme.colors.widget_hover_background};
      border-radius: 5px;
    }

    .icon {
      color: ${(props) => props.theme.colors.inactive};
    }

    &.active {
      font-weight: 700;

      .icon {
        color: ${(p) => p.theme.colors.text}
      }
    }

    .icon-badge {
      position: relative;
    }

    .badge {
      position: absolute;
      top: -10px;
      right: -10px;
      padding: 4px;
      border-radius: 50%;
      background-color: ${(props) => props.theme.colors.main_cta};
    }
  }

  .hidden-item {
    display: none;
  }

  .sub-nav {
    a:first-child {
      border-bottom: 1px solid ${(props) => props.theme.colors.outline};
    }
  }

  .menu-link.arrow {
    .icon {
      color: ${(props) => props.theme.colors.text};
    }
  }
`;

export default { Wrapper };
